/* Stage Shop — size chart unit toggle */
(function () {

  function toIn(cm) {
    return Math.round(parseFloat(cm) / 2.54);
  }

  document.addEventListener('change', function (e) {
    if (e.target.type !== 'checkbox') return;

    var root = e.target.closest('[data-size-chart]');
    if (!root) return;

    var isCm  = e.target.checked;
    var table = root.querySelector('table');
    if (!table) return;

    root.querySelectorAll('.sc-unit-lbl').forEach(function (lbl) {
      var isIn = lbl.textContent.trim() === 'IN';
      lbl.classList.toggle('sc-unit-lbl--on', isCm ? !isIn : isIn);
    });

    table.querySelectorAll('.sc-unit').forEach(function (el) {
      el.textContent = isCm ? '(cm)' : '(in)';
    });

    table.querySelectorAll('.mv').forEach(function (cell) {
      var lo = cell.getAttribute('data-lo');
      var hi = cell.getAttribute('data-hi');
      cell.textContent = isCm
        ? lo + '\u2013' + hi
        : toIn(lo) + '\u2013' + toIn(hi);
    });
  });

}());

/* Open studio hire in new tab */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.site-nav__dropdown a[href*="studio50"]').forEach(function (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  });
}());